/**
 * Hooks up all sliders into the HTML template
 */
export const engageSliderGalleries = (): void => {
  const allSliders = document.querySelectorAll('.js-sliderGallery')

  const engageSlider = (singleSlider: Element) => {
    const slider = tns({
      container: singleSlider,
      controlsContainer: singleSlider,
      controls: false,
      items: 1,
      slideBy: 1,
      autoplay: true,
      autoplayTimeout: 4000,
      autoplayHoverPause: false,
      autoplayButtonOutput: false,
      autoHeight: false,
      mouseDrag: true,
      swipeAngle: false,
      responsive: {
        768: {
          mouseDrag: false,
          autoHeight: false

        }
      }
    })
  }

  allSliders.forEach(slider => {
    engageSlider(slider)
  })
}
